import React from 'react'
import Box from '../../components/simple/box/Box'
import Text from '../../components/simple/text/Text'
import ActionBoxSmall from '../../components/compound/actionBox/ActionBoxSmall'

function ClickerGroups ({ groups, size, title, onClickBehaviour }) {
  const hasNamedGroups = groups.some(item => item.group)

  return (
    <>
      {groups.length > 0 && (
        <Box background="white" direction="column" gap="small" round="small" flex="grow" margin={{ top: 'medium', bottom: 'small' }}>
          <Box direction="row-responsive" justify="between" pad={{ horizontal: 'medium', vertical: 'small' }}>
            <Text size="xlarge" weight="bold" color="secondary">{title}</Text>
          </Box>
        </Box>
      )}
      {groups.map(({ group, colour, behaviours }) => (
        <Box key={group || 'ungrouped'} flex={false}>
          {hasNamedGroups && (
            <Box pad={{ horizontal: 'medium' }}>
              <Box border="none" direction="column" gap="small" round="small" margin={{ vertical: 'small', horizontal: 'xsmall' }}>
                <Box direction="row" align="center" gap="small" pad={{ horizontal: 'medium', vertical: 'small' }}>
                  {colour && <Box data-testid="clicker-group-colour" aria-hidden="true" background={colour} pad="xsmall" round="xxsmall" flex={false} />}
                  <Text size="large" weight="bold" color="white">{group || 'Other'}</Text>
                </Box>
              </Box>
            </Box>
          )}
          <Box direction="row" wrap={true} justify="start" pad={{ horizontal: 'medium', top: 'none', bottom: 'none' }}>
            {behaviours.map(behaviour => (
              <ActionBoxSmall
                key={behaviour}
                title={behaviour}
                width={['xsmall', 'small', 'medium'].includes(size) ? '100%' : '240px'}
                onClick={() => onClickBehaviour(behaviour)}
                icon="plus-circle"
              />
            ))}
          </Box>
        </Box>
      ))}
    </>
  )
}

export default ClickerGroups
